import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getRoleList } from "../../services/role.service";
import { OPTIONS_TOAST } from "../../shared/consts";

const initialState = {
  isLoading: false,
  list: [],
  currentPageList: 1,
  totalPageList: 1,
  sizePageList: 1,
  errorMsg: null,
};

/** SLICES */
export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoleList.pending, (state, action) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(getRoleList.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload.data;
        return {
          ...state,
          isLoading: false,
          list: data,
          errorMsg: null,
        };
      }
      return state;
    });
    builder.addCase(getRoleList.rejected, (state, action) => {
      toast.dismiss();
      toast.error(`${action.payload}`, OPTIONS_TOAST);
      return {
        ...state,
        isLoading: false,
        errorMsg: action.payload,
      };
    });
  },
});

// export const { } = roleSlice.actions;
export default roleSlice.reducer;
